import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {map, switchMap} from 'rxjs/operators';
import {BehaviorSubject, from} from 'rxjs'

const routes = {
  filter: '/contract/digital/filter-contract',
  filterMoha: '/contract-employment/digital/filter-contract', //+
  filterBusiness: '/contract/create-side/digital-contract/filter',
  delete: (id: string) => `/contract/digital/delete/${id}`,
  createContract: '/contract/digital/file',
  createContractMoha: '/contract-employment/digital/file',//+
  getContractById: (id: string) => `/contract/digital/get-by-id/${id}`,
  getContractMohaById: (id: string) => `/contract-employment/digital/get-by-id/${id}`,//+
  getContractByIdAnonymous: (id: string, tenantId: string, hashKey: string) => `/anonymous/digital/get-by-id/${id}/${tenantId}/${hashKey}`,
  downloadContract: (id: string) => `/file/download/contract-digital-files-zip/${id}`,
  downloadContractAnonymous: (id: string, tenantId: string, hashKey: string) => `/anonymous/file/download/contract-digital-files-zip-anonymous/${id}/${tenantId}/${hashKey}`,
  getFile: (attachmentId: string) => `/file/view/digital/view-file-by-id/${attachmentId}`,
  getFileAnonymous: (attachmentId: string, tenantId: string, hashKey: string) => `/anonymous/file/view/digital/view-file-by-id/${attachmentId}/${tenantId}/${hashKey}`,
  activeContract: (contractId: string) => `/contract/digital/active/${contractId}`,
  parentContract: '/contract/digital/filter-contract-parent-by-name-or-code',
  updateContract: '/contract/digital/file/update',
  updateContractMoha: '/contract-employment/digital/file/update',//+
  getContractChilds: (id: string) => `/contract/relation/${id}`,
  checkBackup: '/contract/digital/is-backup'
};

@Injectable({
  providedIn: 'root'
})

export class DigitalContractService {
  reloadFilter = new BehaviorSubject(null);
  effectiveDateNewContract = new BehaviorSubject(null);
  filterContract = new BehaviorSubject(null);
  isSearch = new BehaviorSubject(null);
  keepFilter = new BehaviorSubject(null);

  constructor(private apiService: ApiService) {
  }

  // Lấy danh sách hợp đồng
  getDigitalContract(filter: any) {
    return this.apiService.postSilently(routes.filter, filter)
      .pipe(map(res => {
        return res;
      }));
  }

  getDigitalContractMoha(filter: any) {
    return this.apiService.postSilently(routes.filterMoha, filter)
      .pipe(map(res => {
        return res;
      }));
  }

  // Lấy danh sách hợp đồng số  hóa
  getDigitalContractBusiness(filter: any) {
    return this.apiService.postSilently(routes.filterBusiness, filter)
      .pipe(map(res => {
        return res;
      }));
  }

  // tao files hợp đồng
  createContract(contract, files: File[], attachFile: File[]) {
    const formData = new FormData();
    formData.append('contract', contract);
    for (const file of files) {
      formData.append('filesNewUpload', file);
    }
    for (const file of attachFile) {
      formData.append('filesAttachment', file);
    }
    return this.apiService.postUpload(routes.createContract, formData)
      .pipe(map(res => {
        return res;
      }));
  }

  createContractMoha(contract, files: File[], attachFile: File[]) {
    return from(this.buildEmploymentDigitalFilePayload(contract, files, attachFile))
      .pipe(
        switchMap(payload => this.apiService.post(routes.createContractMoha, payload)),
        map(res => {
          return res;
        })
      );
  }

  // cập nhật files hợp đồng
  updateContract(contract, files: File[], attachFile: File[]) {
    const formData = new FormData();
    formData.append('contract', contract);
    for (const file of files) {
      formData.append('filesNewUpload', file);
    }

    for (const file of attachFile) {
      formData.append('filesAttachment', file);
    }
    return this.apiService.postUpload(routes.updateContract, formData)
      .pipe(map(res => {
        return res;
      }));
  }

  updateContractMoha(contract, files: File[], attachFile: File[]) {
    return from(this.buildEmploymentDigitalFilePayload(contract, files, attachFile))
      .pipe(
        switchMap(payload => this.apiService.post(routes.updateContractMoha, payload)),
        map(res => {
          return res;
        })
      );
  }

  // Delete contract
  deleteContract(id: string) {
    return this.apiService.get(routes.delete(id))
      .pipe(map(res => {
        return res;
      }));
  }

  // View contract
  getContractById(id: string) {
    return this.apiService.get(routes.getContractById(id))
      .pipe(map(res => {
        return res;
      }));
  }

  // View contract (silent): popup xem tham chieu tu add-document, khong block UI toan trang
  getContractByIdSilently(id: string) {
    return this.apiService.getSilently(routes.getContractById(id))
      .pipe(map(res => {
        return res;
      }));
  }

  getContractMohaById(id: string) {
    return this.apiService.get(routes.getContractMohaById(id))
      .pipe(map(res => {
        return res;
      }));
  }

  getContractByIdAnonymous(id: string, tenantId: string, hashKey: string) {
    return this.apiService.get(routes.getContractByIdAnonymous(id, tenantId, hashKey))
      .pipe(map(res => {
        return res;
      }));
  }

  getContractFiles(id: string) {
    return this.apiService.getFile(routes.getFile(id))
      .pipe(map(res => {
        return res;
      }));
  }

  getContractFilesAnonymous(id: string, tenantId: string, hashKey: string) {
    return this.apiService.getFile(routes.getFileAnonymous(id,tenantId,hashKey))
      .pipe(map(res => {
        return res;
      }));
  }

  // download contract
  downloadContract(id: string) {
    return this.apiService.getFilePostMethod(routes.downloadContract(id), {})
      .pipe(map(res => {
        return res;
      }));
  }

  downloadContractAnonymous(id: string, tenantId: string, hashKey: string) {
    return this.apiService.getFilePostMethod(routes.downloadContractAnonymous(id,tenantId,hashKey), {})
      .pipe(map(res => {
        return res;
      }));
  }

  downloadContractFail(id: string) {
    return this.apiService.post(routes.downloadContract(id), {})
      .pipe(map(res => {
        return res;
      }));
  }

  downloadContractFailAnonymous(id: string, tenantId: string, hashKey: string) {
      return this.apiService.post(routes.downloadContractAnonymous(id,tenantId,hashKey), {})
        .pipe(map(res => {
          return res;
        }));
    }

  // Active Contract
  activeContract(id: string) {
    return this.apiService.get(routes.activeContract(id))
      .pipe(map(res => {
        return res;
      }))
  }

  getContractParent(body: object) {
    return this.apiService.post(routes.parentContract, body)
      .pipe(map(res => {
        return res;
      }))
  }

  getContractChild(id: string) {
    return this.apiService.get(routes.getContractChilds(id))
      .pipe(map(res => {
        return res;
      }))
  }

  // kiem tra co trong trang thai backup hay khong
  checkBackup() {
    return this.apiService.getSilently(routes.checkBackup)
      .pipe(map(res => {
        return res;
      }))
  }

  private fileToBase64Payload(file: File): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve({
        fileName: file.name,
        file: reader.result as string
      });
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(file);
    });
  }

  private filesToBase64Payload(files: File[] = []): Promise<any[]> {
    if (!files || files.length === 0) {
      return Promise.resolve([]);
    }
    return Promise.all(files.map(file => this.fileToBase64Payload(file)));
  }

  private buildEmploymentDigitalFilePayload(contract: any, files: File[] = [], attachFile: File[] = []): Promise<any> {
    return Promise.all([
      this.filesToBase64Payload(files),
      this.filesToBase64Payload(attachFile)
    ]).then(([filesNewUpload, filesAttachment]) => ({
      contract,
      filesNewUpload,
      filesAttachment
    }));
  }
}
